export const numberBR = (value = 0, decimal = 2) => (
  parseFloat(value.toFixed(decimal)).toLocaleString('pt-br', {
    minimumFractionDigits: decimal,
  })
);

export const moneyBR = (value = 0, decimal = 2) => `R$ ${numberBR(value, decimal)}`;

export const percentageBR = (value = 0) => `${numberBR(value, 2)}%`;

export const onlyNumber = (value) => (value || '').toString().replace(/[^0-9]/g, '');

export const numberBRToFloat = (value) =>
  parseFloat(
(value || '')
    .replace(/[^0-9,.]/g, '')
    .replace('.', '')
    .replace(',', '.'),
  10,
);
